import React from "react";
import Select from "./Select";
import Button from "./Button";

const Form = ({ formData, onSubmit, handleChange, handleCountryChange }) => {
  return (
    <form
      id="currencyForm"
      className="flex flex-col gap-4 lg:gap-6 w-full sm:w-[70%] bg-white px-6 py-4 rounded-3xl shadow-lg mx-auto -mt-4 lg:w-full lg:max-w-7xl lg:px-8 lg:py-6"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <p className="text-black font-bold text-xs lg:text-sm lg:min-w-[180px] lg:mr-4 lg:self-center sm:hidden">
        Explore Rates and Save on Transfers
      </p>

      {/* Country From Section */}
      <div className="flex">
        <Select
          isCountrySelector
          label="Money Sent from"
          name="countryFrom"
          defaultValue={formData?.countryFrom?.code || "US"}
          onChange={(country) => handleCountryChange(country, "countryFrom")} // Handle countryFrom change
          containerClass="w-[70%] lg:w-full"
          classes="lg:w-full"
        />
        <div className="w-[30%] bg-[#7B3BCC] border border-grey-400 rounded-e-lg flex items-center justify-center h-[60px] text-white lg:min-w-[90px] relative top-[27px] sm:top-[36px]">
          <p className="font-semibold text-xs sm:text-sm lg:text-base whitespace-nowrap">
            {formData?.countryFrom?.currencies[0]?.code +
              " " +
              `(${formData?.countryFrom?.currencies[0]?.symbol})`}
          </p>
        </div>
      </div>

      {/* Country To Section */}
      <div className="flex">
        <Select
          isCountrySelector
          label="Money Sent to"
          name="countryTo"
          defaultValue={formData?.countryTo?.code || "IN"}
          value={formData?.countryTo}
          onChange={(country) => handleCountryChange(country, "countryTo")} // Handle countryTo change
          containerClass="w-[70%] lg:w-full"
        />
        <div className="w-[30%] bg-[#7B3BCC] border rounded-e-lg flex items-center justify-center h-[60px] text-white lg:min-w-[90px] relative top-[27px] sm:top-[36px]">
          <p className="font-semibold text-xs sm:text-sm lg:text-base whitespace-nowrap">
            {formData?.countryTo?.currencies[0]?.code +
              " " +
              `(${formData?.countryTo?.currencies[0]?.symbol})`}
          </p>
        </div>
      </div>

      {/* Amount Input Section */}
      <div className="mb-4 lg:mb-0 flex justify-start items-center w-full">
        <div className="bg-[#7B3BCC] lg:flex lg:items-center border rounded-l-lg text-white h-[60px] px-3 font-bold flex items-center">
          Amount
        </div>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          name="amount"
          value={formData?.amount || ""}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d{0,7}$/.test(value)) {
              handleChange(e);
            }
          }}
          placeholder="Enter amount"
          className="h-[60px] w-full border-none bg-[rgb(243,249,255)] text-black py-6 px-3 rounded-e-md ring-0 focus:outline-none placeholder:text-sm lg:placeholder:text-base"
          maxLength="7"
        />
      </div>

      {/* Submit Button */}
      <div className="w-full lg:self-center">
        <Button
          btnText="Find Best Transfer Rates"
          classes="w-full bg-[#7B3BCC] text-sm lg:text-[14px] text-white font-bold py-3 lg:py-4 hover:bg-[#6a30b5] transition-colors rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7B3BCC] focus:ring-offset-2"
          type="submit"
        />
      </div>
    </form>
  );
};

export default Form;
